import firebase from 'firebase'

var config = {
  apiKey: 'AIzaSyB9wr3uuXYzuTxOG6NiNXp2Sb5PRkx0CEo',
  authDomain: 'meherbabaapp.com',
  databaseURL: 'https://meherbabaapp.firebaseio.com',
  projectId: 'meherbabaapp',
  storageBucket: 'meherbabaapp.appspot.com',
  messagingSenderId: '444912314665'
}
firebase.initializeApp(config)
/* let app = firebase.initializeApp(config)
let db = app.database()
let usersRef = db.ref('Users')

const messaging = firebase.messaging()
messaging.requestPermission()
.then(function () {
  // console.log('Permission Granted')
  return messaging.getToken()
})
.then((currentToken) => {
  // console.log(currentToken)
  db.ref('Users').once('value').then(function (snapshot) {
    var BreakException
    var exists = snapshot.val()
    var keys = Object.keys(exists)
    try {
      keys.forEach(function (key) {
        var User = exists[key]
        // console.log(User)
        if (User === currentToken) {
          throw BreakException
        }
      })
      usersRef.push(currentToken)
    } catch (e) {
      if (e === BreakException) {
        // console.log('Already Exists')
      }
    }
  })
})

messaging.onMessage(function (payload) {
  console.log('message Received', payload)
}) */

export default {
  database: firebase.database(),
  storage: firebase.storage()
}



// WEBPACK FOOTER //
// ./src/service/firebase.js